import { useEffect } from "react";

import {
  ApplyDiscount,
  ApplyDiscountProps,
} from "@/types/gtm/QuoteReviewEvent";

interface ExtendedWindow extends Window {
  dataLayer?: ApplyDiscount[];
}

const useGtmApplyDiscount = (props: ApplyDiscountProps) => {
  const { applyVoucherData, isReady, resetGtmTiger } = props;

  useEffect(() => {
    const triggerPageLoadEvent = () => {
      if (applyVoucherData !== null) {
        const extendedWindow = window as ExtendedWindow;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        extendedWindow.dataLayer.push({
          ...applyVoucherData,
        });
        resetGtmTiger();
      }
    };
    if (isReady) triggerPageLoadEvent();
    return () => {
      // Cleanup code if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export default useGtmApplyDiscount;
